<template>
  <AutoSuggest
    v-model="country"
    :label="$$t('Country of tournament:', 'country-label')"
    :source="suggestCountriesRequest"
    :disabled="isTournamentFieldDisabled('country')"
    name="country"
    :placeholder="$$t('Start enter country', 'country-placeholder')"
    display-property="text"
    :tooltip="
      $$t(
        'Host country. Will be used as search parameter',
        'host-country-tooltip'
      )
    "
  />
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import AutoSuggest from '@/components/molecules/form/autoComplete/HeraAutosuggest';
import { translate } from '@/mixins/translate';
export default {
  name: 'TournamentHostCountrySetting',
  components: {
    AutoSuggest,
  },
  mixins: [translate('_web_tournament_additional_settings')],

  computed: {
    ...mapGetters(['currentTournamentInfo', 'isTournamentFieldDisabled']),
    country: {
      get() {
        return !this.$lodash.isEmpty(this.currentTournamentInfo) &&
          this.currentTournamentInfo.country &&
          this.currentTournamentInfo.country_id
          ? {
              text: this.currentTournamentInfo.country,
              value: this.currentTournamentInfo.country_id,
            }
          : null;
      },
      set(newVal) {
        newVal &&
          this.updateCurrentTournament({
            country: newVal.text,
            country_id: newVal.id,
            component: 'info',
          });
      },
    },
  },
  methods: {
    ...mapMutations(['updateCurrentTournament']),
    ...mapActions(['suggestCountriesRequest']),
  },
};
</script>
